import { useMemo } from "react";
import Button from "./Button";
import { renderMarkdownToHtml } from "../../utils/markdown";

const NotificationModal = ({
  markdownContent,
  onClose,
  'data-testid': dataTestId = 'notification-modal',
}) => {
  const renderedContent = useMemo(
    () => renderMarkdownToHtml(markdownContent),
    [markdownContent]
  );

  return (
    <div
      className="overlayHolder bg-black/30 dark:bg-black/60 fixed inset-0 flex justify-center top-0 z-[999] px-5 py-8"
      data-testid={dataTestId}
    >
      <div className="modalHlder bg-white dark:bg-darkThemeModalBg dark:shadow-darkThemeDropdownMenuShadow rounded-2xl border border-black/10 w-full max-w-2xl my-auto p-6 sm:p-8 overflow-auto max-h-[85vh]">
        <div className="flex flex-col gap-6">
          <div
            className="max-w-none text-dark-grey dark:text-white [&_h1]:text-2xl [&_h1]:font-semibold [&_h1]:mb-3 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mb-3 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:mb-2 [&_p]:leading-6 [&_p]:mb-4 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-2 [&_li]:leading-6 [&_hr]:my-5 [&_hr]:border-black/10 dark:[&_hr]:border-white/10"
            dangerouslySetInnerHTML={{ __html: renderedContent }}
          />
          <div className="flex justify-end">
            <Button
              onClick={onClose}
              className="flex justify-center items-center min-w-24 bg-theme px-5 py-3 text-white text-base font-semibold leading-5 tracking-[-0.32px] rounded-md cursor-pointer h-10 hover:bg-theme/80 transition-all duration-300 ease-in-out"
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
